<div class="grid grid-cols-[1fr_min-content] grid-rows-2 items-center gap-3">
	<div>{{ label$ | async }}</div>
	<div class="self-start">{{ amount | centsToDollars }}</div>
	<div class="col-span-2 flex capitalize">
		<app-pill mode="primary-alt" size="xsmall" [testHook]="testHooks.Pill">{{
			pillLabel
		}}</app-pill>
	</div>
</div>
